import { Box, Button, TextField } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../../../ThemeContext/ThemeObject';

export const CounterWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  borderRadius: 5,
  border: '1px solid #D5DCE6',
  fontSize: 30
}));

export const CounterButton = styled(Button)(() => ({
  minWidth: 40,
  height: 40,
  fontSize: 20,
  color: '#084D6D',
  backgroundColor: '#DEF3F2',
  borderRadius: 0,
  '&:hover': {
    backgroundColor: '#CCEDEB'
  },
  '&:active': {
    backgroundColor: '#3a9a95'
  }
}));

export const CounterDisplay = styled(Box)(() => ({
  width: 60,
  height: 40,
  position: 'relative',
  overflow: 'hidden',
  textAlign: 'center',
  color: '#333C48',
  fontSize: 16
}));

export const CounterInput = styled(TextField)({
  position: 'absolute',
  zIndex: 2,
  width: '100%',
  height: '100%',
  left: 0,
  right: 0,
  '& .MuiInputBase-root': {
    height: '100%',
    '& input': {
      textAlign: 'center',
      padding: 0,
      height: '100%',
      lineHeight: '40px',
      fontSize: 16
    }
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  },
  '& .MuiOutlinedInput-root': {
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    }
  }
});
